import { AtlasActionTypes } from "../AtlasActionTypes";
import { AtlasState, getMutableCopyOfAtlasState } from "../AtlasStateTypes";
import { AtlasActions } from "../AtlasActions";

const RenewalFollowUpFormPageReducer = (
  oldState: AtlasState,
  action: AtlasActions
): AtlasState => {
  const newState = getMutableCopyOfAtlasState(oldState);
  switch (action.type) {
    case AtlasActionTypes.ActualResultsSummaryPageSetInitialForm:
      newState.actualResultsSummaryPageState.form = action.form;
      newState.loadingState.isLoading = false;
      newState.messageState.messages = [];
      return newState;
    case AtlasActionTypes.ActualResultsSummaryPageUpdateForm:
      newState.actualResultsSummaryPageState.form = action.form;
      return newState;
    case AtlasActionTypes.ActualResultsSummaryPageShowFormUpdateSuccessful:
      newState.actualResultsSummaryPageState.form = action.form;
      return newState;
  }

  return newState;
};

export default RenewalFollowUpFormPageReducer;
